module.exports = __webpack_public_path__ + "videos/pencil-filters_en.e181dac.mp4";